import BusinessInformationPage from '../pages/BusinessInformationPage.vue';
import EditBusinessInformationPage from '../pages/EditBusinessInformationPage.vue';
import BusinessInformationUploadDocsPage from '../pages/BusinessInformationUploadDocsPage.vue';

const businessInformationRoutes = [
  {
    path: '/business-information',
    name: 'اطلاعات کسب و کار',
    component: BusinessInformationPage,
    meta: {
      roles: ['merchant', 'supplier'],
    },
  },
  {
    path: '/business-information/edit/:stepId',
    name: 'ویرایش اطلاعات کسب و کار',
    component: EditBusinessInformationPage,
    meta: {
      roles: ['merchant'],
    },
  },
    {
    path: "business-information/:id/edit",
    name: "ویرایش کسب و کار توسط  بازایاب",
    component: EditBusinessInformationPage,
  },
  {
    path: '/upload-documents',
    name: 'ویرایش اطلاعات کسب و کار',
    component: BusinessInformationUploadDocsPage,
    meta: {
      roles: ['merchant', 'supplier'],
    },
  },
];

export default businessInformationRoutes;
